import { translate } from '@teamleader/i18n';
import { IconWarningBadgedSmallFilled } from '@teamleader/ui-icons';
import { DateTime } from 'luxon';
import React from 'react';

import { BoxProps } from '../../../../Components/UI/Box';
import StatusLabel from '../../../../Components/UI/StatusLabel';
import { apiFormatDate, fromISO, isAfter } from '../../../../Utils/date';

interface DueDateLabelProps extends BoxProps {
  dueDate: string;
  dateFormat: string;
}

const DueDateLabel: React.FC<DueDateLabelProps> = ({ dueDate, dateFormat, ...rest }) => {
  const date = fromISO(dueDate);
  const today = DateTime.local().startOf('day');

  if (today.hasSame(date, 'day')) {
    return <StatusLabel {...rest}>{translate('date.today')}</StatusLabel>;
  }

  if (isAfter(today, date)) {
    return (
      <StatusLabel {...rest}>
        <IconWarningBadgedSmallFilled />
        &nbsp;{translate('overdue', { amount: today.diff(date, 'day').days })}
      </StatusLabel>
    );
  }

  return <StatusLabel {...rest}>{apiFormatDate(date, dateFormat)}</StatusLabel>;
};

export default DueDateLabel;
